// extracted by mini-css-extract-plugin
export default {"notice":"NoticePriceService_notice__-MWWu","price":"NoticePriceService_price__YNF8g","priceVariant":"NoticePriceService_priceVariant__BJ89D"};